import React from 'react';
import { confirmDialog } from 'primereact/confirmdialog';

interface PermissionConfirmationOptions {
  branchName: string;
  isAddingPermission: boolean;
  onConfirm: () => Promise<void>;
}

export const showPermissionConfirmationDialog = ({
  branchName,
  isAddingPermission,
  onConfirm,
}: PermissionConfirmationOptions) => {
  const actionType = isAddingPermission ? 'הוספת' : 'הסרת';
  const actionDescription = isAddingPermission
    ? 'הוספת הרשאת גישה למשתמש עבור שלוחה זו'
    : 'הורדת הרשאת הגישה של המשתמש עבור שלוחה זו';

  confirmDialog({
    message: (
      <div style={{ direction: 'rtl', textAlign: 'right' }}>
        <p
          style={{
            marginBottom: '15px',
            fontWeight: 'bold',
            fontSize: '1.1rem',
          }}
        >
          שים לב,
        </p>
        <p style={{ marginBottom: '10px' }}>
          הינך עומד לשנות את הרשאת הגישה עבור השלוחה{' '}
          <strong>"{branchName}"</strong>
        </p>
        <p style={{ marginBottom: '10px' }}>
          לפעולה זו יש משמעות של {actionDescription}.
        </p>
        <p style={{ marginBottom: '10px' }}>
          באם אתה בטוח שתרצה להמשיך, לחץ על "אשר".
        </p>
        <p style={{ color: '#666', fontSize: '0.9rem' }}>
          שים לב, בכל רגע נתון תוכל לשנות את ההרשאה...
        </p>
      </div>
    ),
    header: `אישור ${actionType} הרשאה`,
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'אשר',
    rejectLabel: 'ביטול',
    acceptClassName: isAddingPermission
      ? 'p-button-success'
      : 'p-button-danger',
    rejectClassName: 'p-button-secondary',
    accept: onConfirm,
    reject: () => {
      // User cancelled
    },
  });
};
